import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "notification-panel__content" }
const _hoisted_4 = { class: "form estate-setup-form" }
const _hoisted_5 = { class: "form-inline-group fg1" }
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = { class: "form-field multiple-inputs no-wrap checkboxes" }
const _hoisted_9 = {
  key: 0,
  class: "checkbox-switch"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_12 = { class: "check-label" }
const _hoisted_13 = {
  key: 1,
  class: "checkbox"
}
const _hoisted_14 = ["checked"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_16 = { class: "checkbox" }
const _hoisted_17 = ["checked"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_19 = { class: "checkbox-switch" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_22 = { class: "check-label" }
const _hoisted_23 = { class: "page-header" }
const _hoisted_24 = { class: "width-wrap" }
const _hoisted_25 = { class: "notification-panel__content" }
const _hoisted_26 = { class: "form estate-setup-form" }
const _hoisted_27 = { class: "form-inline-group fg1" }
const _hoisted_28 = { class: "form-field" }
const _hoisted_29 = { class: "form-field" }
const _hoisted_30 = { class: "form-field multiple-inputs no-wrap checkboxes" }
const _hoisted_31 = {
  key: 0,
  class: "checkbox-switch"
}
const _hoisted_32 = ["disabled"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_34 = { class: "check-label" }
const _hoisted_35 = {
  key: 1,
  class: "checkbox"
}
const _hoisted_36 = ["checked"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_38 = { class: "checkbox" }
const _hoisted_39 = ["checked"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_41 = { class: "checkbox-switch" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_44 = { class: "check-label" }
const _hoisted_45 = { class: "virtual-tour" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "virtual-tour" }
const _hoisted_48 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_FlashMessage = _resolveComponent("FlashMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_AdDeveloperProjectInfo = _resolveComponent("AdDeveloperProjectInfo")!
  const _component_AdDeveloperProjectItem = _resolveComponent("AdDeveloperProjectItem")!
  const _component_AdDeveloperProjectList = _resolveComponent("AdDeveloperProjectList")!
  const _component_FixedElement = _resolveComponent("FixedElement")!
  const _component_AdPreview = _resolveComponent("AdPreview")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _createElementVNode("title", null, _toDisplayString(_ctx.$t('AdDeveloperProjectDetail.title')) + " " + _toDisplayString(_ctx.form.title), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["notification-panel", _ctx.notificationClass]),
        ref: "topNotificationPanel"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["width-wrap", { 'disabled-all': _ctx.isLoading }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
            return (_openBlock(), _createBlock(_component_FlashMessage, {
              key: index,
              message: message
            }, {
              default: _withCtx(() => [
                (message.code == 'confirmemail')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_ctx.isConfirmEmailSent)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "button button--warning reversed",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendConfirmEmail && _ctx.sendConfirmEmail(...args)))
                          }, _toDisplayString(_ctx.$t('AdForm.button-send-confirm-email')), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('AdForm.confirm-email-success', { email: _ctx.user.email })), 1))
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["message"]))
          }), 128)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("form", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    class: "button button--primary",
                    to: { name: 'AdDeveloperProjectFormEdit', params: { adFrontId: _ctx.adFrontId } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdDeveloperProjectDetail.button-edit-short' : 'AdDeveloperProjectDetail.button-edit')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "button button--primary reversed",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onShowPreview && _ctx.onShowPreview(...args)))
                  }, _toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdForm.button-preview-short' : 'AdForm.button-preview')), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.isMobile)
                    ? (_openBlock(), _createBlock(_component_multiselect, {
                        key: 0,
                        class: "multiselect-statuses w200",
                        modelValue: _ctx.publishStatus,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.publishStatus) = $event)),
                        options: _ctx.publishStatuses,
                        "show-labels": false,
                        searchable: false,
                        "allow-empty": false
                      }, {
                        singleLabel: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdForm.status-change')), 1)
                        ]),
                        option: _withCtx(({ option }) => [
                          (option === 'publish')
                            ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isPublished) = $event)),
                                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                  disabled: !_ctx.form.isEmailConfirmed || _ctx.form.isArchived
                                }, null, 40, _hoisted_10), [
                                  [_vModelCheckbox, _ctx.isPublished]
                                ]),
                                _hoisted_11,
                                _createElementVNode("span", _hoisted_12, [
                                  (_ctx.form.isPublished)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.published')), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.unpublished')), 1)
                                      ], 64))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (option === 'archive')
                            ? (_openBlock(), _createElementBlock("label", _hoisted_13, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.archived')), 1),
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: _ctx.form.isArchived,
                                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                                }, null, 40, _hoisted_14),
                                _hoisted_15
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("label", _hoisted_16, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.archived')), 1),
                          _createElementVNode("input", {
                            type: "checkbox",
                            checked: _ctx.form.isArchived,
                            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                          }, null, 40, _hoisted_17),
                          _hoisted_18
                        ]),
                        _createElementVNode("label", _hoisted_19, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isPublished) = $event)),
                            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                            disabled: !_ctx.form.isEmailConfirmed || _ctx.form.isArchived
                          }, null, 40, _hoisted_20), [
                            [_vModelCheckbox, _ctx.isPublished]
                          ]),
                          _hoisted_21,
                          _createElementVNode("span", _hoisted_22, [
                            (_ctx.form.isPublished)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.published')), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.unpublished')), 1)
                                ], 64))
                          ])
                        ])
                      ], 64))
                ])
              ])
            ])
          ])
        ], 2)
      ], 2),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('AdDeveloperProjectDetail.title')) + " " + _toDisplayString(_ctx.form.title), 1)
        ])
      ]),
      _createVNode(_component_AdDeveloperProjectInfo, {
        ad: _ctx.form,
        onVirtualtour: _ctx.onVirtualTour,
        onVideo: _ctx.onVideo
      }, null, 8, ["ad", "onVirtualtour", "onVideo"]),
      (_ctx.form && _ctx.form.adId > 0)
        ? (_openBlock(), _createBlock(_component_AdDeveloperProjectItem, {
            key: 0,
            ad: _ctx.form,
            onInserted: _ctx.onEstateInserted
          }, null, 8, ["ad", "onInserted"]))
        : _createCommentVNode("", true),
      (_ctx.form && _ctx.form.adId > 0)
        ? (_openBlock(), _createBlock(_component_AdDeveloperProjectList, {
            key: 1,
            parentAdId: _ctx.form.adId,
            maxFloor: _ctx.form.maxFloor,
            ref: "adDeveloperProjectListComponent"
          }, null, 8, ["parentAdId", "maxFloor"]))
        : _createCommentVNode("", true),
      _createVNode(_component_FixedElement, {
        class: _normalizeClass(["notification-panel", _ctx.notificationClass]),
        ref: "bottomNotificationPanel",
        onChange: _ctx.updateFixedStatus,
        threshold: _ctx.$refs.topNotificationPanel && _ctx.$refs.topNotificationPanel.clientHeight,
        bottomThreshold: _ctx.bottomThreshold
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["width-wrap", { 'disabled-all': _ctx.isLoading }])
          }, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("form", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_router_link, {
                      class: "button button--primary",
                      to: { name: 'AdDeveloperProjectFormEdit', params: { adFrontId: _ctx.adFrontId } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdDeveloperProjectDetail.button-edit-short' : 'AdDeveloperProjectDetail.button-edit')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                      class: "button button--primary reversed",
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onShowPreview && _ctx.onShowPreview(...args)))
                    }, _toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdForm.button-preview-short' : 'AdForm.button-preview')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    (_ctx.isMobile)
                      ? (_openBlock(), _createBlock(_component_multiselect, {
                          key: 0,
                          class: "multiselect-statuses w200",
                          modelValue: _ctx.publishStatus,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.publishStatus) = $event)),
                          options: _ctx.publishStatuses,
                          "show-labels": false,
                          searchable: false,
                          "allow-empty": false
                        }, {
                          singleLabel: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('AdForm.status-change')), 1)
                          ]),
                          option: _withCtx(({ option }) => [
                            (option === 'publish')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_31, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isPublished) = $event)),
                                    onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                    disabled: !_ctx.form.isEmailConfirmed || _ctx.form.isArchived
                                  }, null, 40, _hoisted_32), [
                                    [_vModelCheckbox, _ctx.isPublished]
                                  ]),
                                  _hoisted_33,
                                  _createElementVNode("span", _hoisted_34, [
                                    (_ctx.form.isPublished)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.published')), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.unpublished')), 1)
                                        ], 64))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (option === 'archive')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_35, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.archived')), 1),
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: _ctx.form.isArchived,
                                    onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                                  }, null, 40, _hoisted_36),
                                  _hoisted_37
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("label", _hoisted_38, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDeveloperProjectForm.archived')), 1),
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: _ctx.form.isArchived,
                              onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                            }, null, 40, _hoisted_39),
                            _hoisted_40
                          ]),
                          _createElementVNode("label", _hoisted_41, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isPublished) = $event)),
                              onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                              disabled: !_ctx.form.isEmailConfirmed || _ctx.form.isArchived
                            }, null, 40, _hoisted_42), [
                              [_vModelCheckbox, _ctx.isPublished]
                            ]),
                            _hoisted_43,
                            _createElementVNode("span", _hoisted_44, [
                              (_ctx.form.isPublished)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.published')), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('AdDeveloperProjectForm.unpublished')), 1)
                                  ], 64))
                            ])
                          ])
                        ], 64))
                  ])
                ])
              ])
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["class", "onChange", "threshold", "bottomThreshold"]),
      (_ctx.$refs.bottomNotificationPanel && _ctx.isHeaderFixed)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            style: _normalizeStyle({ height: _ctx.$refs.bottomNotificationPanel.$el.clientHeight + 'px' })
          }, null, 4))
        : _createCommentVNode("", true),
      (_ctx.showPreview)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 3,
            to: "#container"
          }, [
            _createVNode(_component_AdPreview, {
              adFrontId: _ctx.form.adFrontId,
              onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showPreview = false))
            }, null, 8, ["adFrontId"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showVirtualTourModal)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 4,
            to: "#container"
          }, [
            _createVNode(_component_Modal, {
              class: "modal-fullscreen modal-xl",
              onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showVirtualTourModal = false))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("iframe", {
                    src: _ctx.form.virtualTourLink
                  }, null, 8, _hoisted_46)
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.showVideoModal)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 5,
            to: "#container"
          }, [
            _createVNode(_component_Modal, {
              class: "modal-fullscreen modal-xl",
              onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showVideoModal = false))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("iframe", {
                    src: _ctx.form.videoLink
                  }, null, 8, _hoisted_48)
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}